import React from 'react';
import { Divider, Tab, Tabs, Theme, makeStyles } from '@material-ui/core';
import { TabPanel } from '../../components/TabPanel.component';
import { ReservationForm } from './reservation.form';
import { DocumentsForm } from './documents/documents.form';

const useStyles = makeStyles((theme: Theme) => ({
  xsTabsTop: {
    [theme.breakpoints.down('xs')]: {
      marginTop:"50px",
      zIndex:"2"
    },
  }
}));
/**
 * Composant d'onglets pour la modification de réservation
 * 
 * Ce composant :
 * - Affiche les onglets "Réservation" et "Documents"
 * - Gère la navigation entre les différents formulaires
 * - Adapte l'affichage pour les écrans mobiles
 * 
 * Logique métier :
 * - Onglet Réservation : formulaire principal de la réservation
 * - Onglet Documents : gestion des contrats et factures
 * - Responsive design avec ajustement pour mobile
 * 
 * @returns Composant React des onglets de réservation
 */
export const UpdateReservationTabs: React.FC = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = React.useState('reservation');

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <div className={classes.xsTabsTop}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="fullWidth"
        aria-label="menu des réservations"
      >
        <Tab value="reservation" label="Réservation" />
        <Tab value="documents" label="Documents" />
      </Tabs>
      <Divider variant="middle" />
      <TabPanel value={selectedTab} index="reservation">
        <ReservationForm />
      </TabPanel>
      <TabPanel value={selectedTab} index="documents">
        <DocumentsForm />
      </TabPanel>
    </div>
  );
};
